import React, {useEffect, useState} from 'react';
import {OverlayTrigger, Popover, PopoverBody} from "react-bootstrap";
import {toast} from "react-toastify";
import { useISRContext } from '../Hooks/useISRContext';

type TFieldProps = {
    onClose: () => void;
    onFieldSubmit: (categories: []) => void;
}

const PromotionDialog = ({onClose, onFieldSubmit}: TFieldProps) => {
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [cats, setCats] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const isrContext = useISRContext();

    useEffect(() => {
        const fetchIndustryCategories = async () => {
            if (!isrContext?.industryId) {
                setLoading(false);
                return;
            }
            try {
                setLoading(true);
                const responseData = await isrContext?.getIndustryCategories(isrContext?.industryId);
                if (responseData.done === true) {
                    setCats((responseData.data ?? []).map((e: any) => {
                        return { ...e, selected: false };
                    }));
                } else {
                    setCats([]);
                }
            } catch (e) {
                setCats([]);
                toast.error('Failed to load categories');
            } finally {
                setLoading(false);
            }
        };

        fetchIndustryCategories();
    }, []);

    const handleSelection = (index: number) => {
        console.log(index);
        const updatedItems = cats.map((e: any, i: number) => i === index ? {...e, selected: !e.selected} : e)
        setCats(updatedItems);
    };

    const handleSelectAll = () => {
        const updatedItems = cats.map((e: any) => {
            return {...e, selected: !selectAll};
        });
        setCats(updatedItems);
        setSelectAll(!selectAll);
    };

    return (
        <div id="promotion-dialog"
            className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[535px] tw-h-auto`}>
                <div className='tw-flex tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{'Select Categories to Promote'}</h2>
                    {!loading && (
                        <div
                            className="tw-h-[22px] tw-px-3 tw-bg-[#dfe1e6] tw-rounded-[44px] tw-border tw-justify-center tw-items-center tw-gap-1 tw-inline-flex">
                            <div
                                className="tw-text-[#505f79] tw-text-xs tw-font-medium tw-font-['Noto Sans']">{cats.filter((e: any) => {
                                return e.selected;
                            }).length} Selected
                            </div>
                        </div>
                    )}
                </div>

                <div className={`tw-mx-[16px] tw-rounded`}>
                    {loading ? (
                        <div className="tw-flex tw-justify-center tw-items-center tw-py-8">
                            <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-b-2 tw-border-blue-800"></div>
                        </div>
                    ) : (
                        <>
                            <div
                                className="tw-flex tw-flex-wrap tw-gap-5 tw-px-3.5 tw-pt-4 tw-pb-3 tw-mt-3 tw-w-full tw-text-xs tw-font-medium tw-leading-loose tw-border tw-border-solid tw-bg-zinc-200 tw-border-zinc-200 tw-text-slate-500">
                                <div className="tw-flex tw-w-[60%] tw-gap-4 tw-whitespace-nowrap"
                                     onClick={() => handleSelectAll()}>
                                    {selectAll ? <img
                                        alt='category-image'
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/201f175952d8303f3ab134ef1e45a8532593a7d7e5da396e4f6ef39f3157c731?placeholderIfAbsent=true&apiKey=11b9dc92ddc0439bbc56f6fb74e0a224"
                                        className="tw-object-contain tw-shrink-0 tw-self-stretch tw-my-auto tw-w-4 tw-rounded-none tw-aspect-square"
                                    /> : <div className="tw-w-4 tw-h-4 tw-bg-white tw-rounded tw-border tw-border-[#c9c9cf]"/>}
                                    <div>Category</div>
                                </div>
                                <div className="tw-w-[30%]">Number of Models</div>
                            </div>
                            {cats.length <= 0 ? <div
                                className="tw-self-stretch tw-my-auto tw-w-72 tw-text-blue-950">{'No categories found'}</div> : null}
                            <div className={`tw-max-h-[400px] tw-overflow-y-scroll`}>
                                {cats.map((e: any, index: number) => {
                                    return <div
                                        key={e.categoryId}
                                        onClick={() => handleSelection(index)}
                                        className={`tw-flex tw-items-center tw-p-3.5 tw-text-sm tw-leading-snug ${e.selected ? 'tw-bg-indigo-50' : 'tw-bg-white'} tw-border tw-border-solid tw-border-zinc-200`}>
                                        {e.selected ? <img
                                            alt='category-id'
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/201f175952d8303f3ab134ef1e45a8532593a7d7e5da396e4f6ef39f3157c731?placeholderIfAbsent=true&apiKey=11b9dc92ddc0439bbc56f6fb74e0a224"
                                            className="self-stretch object-contain w-4 my-auto rounded-none shrink-0 aspect-square"
                                        /> : <div
                                            className="tw-w-4 tw-h-4 tw-bg-white tw-rounded tw-border tw-border-[#c9c9cf]"/>}
                                        <div className="tw-w-[70%]">
                                            <div
                                                className="tw-ml-2 tw-text-blue-950">{e.categoryName ?? ''}
                                            </div>
                                        </div>
                                        <div className="tw-flex tw-w-[30%]">
                                            <OverlayTrigger
                                                trigger="hover"
                                                placement="right"
                                                overlay={
                                                    <Popover id="popover-component-display-name">
                                                        <PopoverBody
                                                            className="p-1"
                                                            style={{
                                                                backgroundColor: "#ffffff",
                                                                color: "#ffffff",
                                                            }}
                                                        >
                                                            <div className="tw-pl-[27px] tw-pr-[23px] tw-py-[14px]">
                                                                <div
                                                                    className="tw-text-[#6d788c] tw-text-xs tw-font-medium tw-font-['Noto Sans'] tw-leading-tight">Model
                                                                </div>
                                                                {e.models.map((m: any) => {
                                                                    return <div
                                                                        key={e.modelId}
                                                                        className="tw-mt-[16px] tw-text-[#172b4d] tw-text-sm tw-font-normal tw-font-['Noto Sans'] tw-leading-tight">{m.modelName}</div>;
                                                                })}
                                                            </div>
                                                        </PopoverBody>
                                                    </Popover>
                                                }
                                            >
                                                <div
                                                    className="tw-self-stretch tw-px-1 tw-my-auto tw-font-medium tw-text-center tw-text-blue-800 tw-rounded hover:tw-bg-zinc-300 tw-w-[22px]">
                                                    {e.models.length ?? 0}
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    </div>;
                                })}
                            </div>
                        </>
                    )}
                </div>

                <div className={`tw-px-3 tw-my-4 tw-flex tw-gap-2 tw-justify-end`}>
                    <button onClick={onClose} disabled={loading} className='samll-outline-btn'>Cancel</button>
                    <button onClick={() => {
                        if (cats.filter((e: any) => {
                            return e.selected;
                        }).length > 0) {
                            onFieldSubmit(cats.filter((e: any) => {
                                return e.selected;
                            }).map((item: any) => item.categoryId));
                        } else {
                            toast.error('Please select category to continue');
                        }
                    }}
                            disabled={loading}
                            className={`small-filled-btn`}>Promote
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PromotionDialog;